import { render } from "./data_iid.vue?vue&type=template&id=22c44846"
import script from "./data_iid.vue?vue&type=script&lang=js"
export * from "./data_iid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dinaskominfo/Documents/Project/Vue/Erida/eridaApp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__